import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="edit-profile"
export default class extends Controller {
  static targets = ["slug", "slugWarning"]

  connect() {
  }

  slugInput(event) {
    const originalSlug = this.slugTarget.dataset.originalValue;

    // grab current value
    let v = event.target.value;
    // 1) lowercase
    // 2) replace spaces (or runs of spaces) with single hyphens
    // 3) strip out anything that’s not a-z, 0-9 or hyphen
    v = v
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^a-z0-9-]+/g, "");
    this.slugTarget.value = v;

    if (v !== originalSlug) {
      this.#showWarning();
    } else {
      this.#hideWarning();
    }
  }

  #showWarning() {
    this.slugWarningTarget.classList.remove("hidden");
  }

  #hideWarning() {
    this.slugWarningTarget.classList.add("hidden");
  }
}
